import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const boardInfoService = {
    findByBoardInfoID,
    findAllUse,
    addBoardInfo,
    modBoardInfo,
    delBoardInfo, 
    findBoardInfoByType,
};

function findByBoardInfoID(boardInfoID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/boardinfo/findByBoardInfoID/${boardInfoID}`, headers);
}

function findAllUse() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/boardinfo/findAllUse`, headers);
}

function addBoardInfo(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/boardinfo/addBoardInfo`, formData, headers);
}

function modBoardInfo(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/boardinfo/modBoardInfo`, formData, headers);
}

function delBoardInfo(boardInfoID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/boardinfo/delBoardInfo/${boardInfoID}`, headers);
}

function findBoardInfoByType(boardTypeCode) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/boardinfo/findBoardInfoByType/${boardTypeCode}`, headers);
}